import { APIURL } from '../constant/apiConstant'
import ApiService from './apiRequest'
import AsyncStorageFunc from '../utilities/asyncStorage';

  export const getActivePlans = (params) => {
    return new Promise((resolve, reject) => {
      ApiService.getWithToken(APIURL.GET_ACTIVE_PLANS, params)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
  export const saveTINominee = (params) => {
    return new Promise((resolve, reject) => {
      ApiService.postwithtoken(APIURL.POST_POLICY_SAVE_NOMINEE, params).then(res => {
          resolve(res);
        }).catch(err => {
          reject(err);
        });
    });
  }
  export const createTIPolicy = (params) => {
    return new Promise((resolve, reject) => {
      ApiService.postwithtoken(APIURL.POST_POLICY_ISSUANCE, params).then(res => {
          resolve(res);
        }).catch(err => {
          reject(err);
        });
    });
  }
  export const cancelTIPolicy = (params) => {
    return new Promise((resolve, reject) => {
      ApiService.postwithtoken(APIURL.POST_POLICY_CANCELLATION, params).then(res => {
          resolve(res);
        }).catch(err => {
          reject(err);
        });
    });
  }

  export const getCityState = (params) => {
    return new Promise((resolve, reject) => {
      ApiService.getWithToken(APIURL.TI_GET_CITY_STATE, params).then(res => {
          resolve(res);
        }).catch(err => {
          reject(err);
        });
    });
  }
  export const getNomineeRelations = (params) => {
    return new Promise((resolve, reject) => {
      ApiService.getWithToken(APIURL.TI_GET_NOMINEE_RELATION, params).then(res => {
          resolve(res);
        }).catch(err => {
          reject(err);
        });
    });
  }

  export const policyDetails = () => {
    return new Promise((resolve, reject) => {
      ApiService.getWithToken(APIURL.TI_GET_POLICY_DETAILS).then(res => {
          resolve(res);
        }).catch(err => {
          reject(err);
        });
    });
  }
  export const tripIsuranceDisputeDropdown = () => {
    return new Promise((resolve, reject) => {
      ApiService.getWithToken(APIURL.TRIP_DISPUTE_DROPDOWN)
        .then((res) => {
          resolve(res?.data || []);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };
  export const tripIsuranceRaiseDispute = (params) => {
    return new Promise((resolve, reject) => {
      ApiService.postwithtoken(APIURL.TRIP_RAISE_DISPUTE, params)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };
  export const tripIsuranceDisputeHistory = (params) => {
    return new Promise((resolve, reject) => {
      ApiService.postwithtoken(APIURL.TRIP_DISPUTE_HISTORY, params)
        .then((res) => {
          resolve(res?.data || []);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };
  export const tripIsuranceDisputeCount = (params) => {
    return new Promise((resolve, reject) => {
      ApiService.postwithtoken(APIURL.TRIP_DISPUTE_COUNT, params)
        .then((res) => {
          resolve(res?.data || []);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };
  export const tripIsuranceDisputeList = () => {
    return new Promise((resolve, reject) => {
      ApiService.getWithToken(APIURL.TRIP_DISPUTE_STATMENT)
        .then((res) => {
          resolve(res?.data || []);
        })
        .catch((err) => {
          // debugger
          reject(err);
        });
    });
  };
  export const tripIsuranceDisputeByTxnNo = (params) => {
    return new Promise((resolve, reject) => {
      ApiService.postwithtoken(APIURL.TRIP_DISPUTE_BY_TXN_NO, params)
        .then((res) => {
          resolve(res?.data || []);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };
  export const tripIsuranceDisputeFilter = (params) => {
    return new Promise((resolve, reject) => {
      ApiService.postwithtoken(APIURL.TRIP_DISPUTE_FILTER, params)
        .then((res) => {
          resolve(res?.data || []);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };
  export const getTripTransactionList = async () => {
    let token = await AsyncStorageFunc.getData('TOKEN');
    let deviceId = await AsyncStorageFunc.getData('deviceId');
    return new Promise((resolve, reject) => {
        ApiService.getWithToken(APIURL.GET_TRIP_TRANSACTIONS).then(res => {
          resolve(res);
        }).catch(err => {
          reject(err);
        });
      
    });
  }
  export const downloadTICertificate = async (coiNo) => {
    let token = await AsyncStorageFunc.getData('TOKEN');
    let deviceId = await AsyncStorageFunc.getData('deviceId');
    return new Promise((resolve, reject) => {
        ApiService.getWithToken(`${APIURL.DOWNLOAD_TRIP_INSURANCE_CERTIFICATE}${coiNo}`).then(res => {
          resolve(res);
        }).catch(err => {
          reject(err);
        });
      
    });
  }
  export const tripInsuraceAutoRenewalOptOut = (params) => {
    return new Promise((resolve, reject) => {
      ApiService.getWithToken(APIURL.TRIP_INSURANCE_AUTO_RENEWAL_OPT_OUT, params)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }